module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_Leicester.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_Leicester.png
// module id = 2188
// module chunks = 4